export const getPageLoader = (store) => store.pageLoader.page_loader || false;
